// extracted by mini-css-extract-plugin
module.exports = {"InfErrorPage":"InfErrorPage--3UV3O","logo":"logo--1qPHY","remind":"remind--1eoWo","remind_icon":"remind_icon--2vGjF","remind_text":"remind_text--1GjYq"};